import { ref } from 'vue'
import { AUTH_PERSISTENT_KEYS } from '@/constants/auth-persistent.constant'
import { setAccessToken } from '@/contexts/auth-context'

export const token = ref<string | null>(null)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const user = ref<any>(null)

/**
 * Initialize auth from localStorage
 */
export function initAuth() {
  const storedToken = localStorage.getItem(AUTH_PERSISTENT_KEYS.TOKEN)
  const storedUser = localStorage.getItem(AUTH_PERSISTENT_KEYS.USER)

  if (storedToken) {
    token.value = storedToken
    setAccessToken(storedToken)
  }

  if (storedUser) {
    try {
      user.value = JSON.parse(storedUser)
    } catch {
      console.warn('Invalid stored user data')
      user.value = null
    }
  }
}

/**
 * Set token and user into state & storage
 */
export function setAuth(newToken: string, newUser: unknown) {
  token.value = newToken
  user.value = newUser
  localStorage.setItem(AUTH_PERSISTENT_KEYS.TOKEN, newToken)
  localStorage.setItem(AUTH_PERSISTENT_KEYS.USER, JSON.stringify(newUser))
  setAccessToken(newToken)
}

/**
 * Clear auth
 */
export function clearAuth() {
  token.value = null
  user.value = null
  localStorage.removeItem(AUTH_PERSISTENT_KEYS.TOKEN)
  localStorage.removeItem(AUTH_PERSISTENT_KEYS.USER)
  localStorage.removeItem(AUTH_PERSISTENT_KEYS.EXPIRES_AT)
  setAccessToken(null)
}
export function isSuperAdmin(): boolean {
  return !!user.value?.admin?.roles?.some((role: { superAdmin?: boolean }) => role.superAdmin === true)
}

/**
 * Check whether the current admin has a given permission (super admins have all permissions).
 * Matches by permission `name` (slug) or `label`.
 */
export function hasPermission(permissionName: string): boolean {
  if (isSuperAdmin()) return true
  return !!user.value?.admin?.roles?.some((role: { permissions?: Array<{ name?: string; label?: string }> }) =>
    role.permissions?.some((p) => p.name === permissionName || p.label === permissionName)
  )
}
